import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const NAV = [
  { to: "/tjenester", label: "Tjenester" },
  { to: "/bunad", label: "Bunad" },
  { to: "/brudekjoler", label: "Brudekjoler" },
  { to: "/sykurs", label: "Sykurs" },
  { to: "/priser", label: "Priser" },
  { to: "/handbok", label: "Håndbok" },
  { to: "/galleri", label: "Galleri" },
  { to: "/om-liisa", label: "Om Liisa" },
  { to: "/kontakt", label: "Kontakt" },
];

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors duration-300 ${isActive ? "text-[#8C6E48]" : "text-[#1A1A1A] hover:text-[#8C6E48]"}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/85 border-b border-[#E5E0D8]" data-testid="site-header">
      <div className="flex items-center justify-between px-6 md:px-16 lg:px-24 h-20">
        <Link to="/" className="flex flex-col leading-none" data-testid="logo-link">
          <span className="font-serif-display text-2xl md:text-[1.7rem] font-semibold tracking-tight">SømSignature</span>
          <span className="text-[0.62rem] tracking-[0.3em] uppercase text-[#8C6E48] mt-1">by Liisa Lipasina</span>
        </Link>
        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} data-testid={`nav-${n.to.slice(1)}`}>{n.label}</NavLink>
          ))}
          <Link to="/bestill" className="px-5 py-2.5 bg-[#1A1A1A] text-[#FDFBF7] text-sm tracking-wide hover:bg-[#8C6E48] transition-colors duration-300" data-testid="header-book-btn">
            Bestill tid
          </Link>
        </nav>
        <button className="lg:hidden p-2" onClick={() => setOpen(!open)} aria-label="Meny" data-testid="mobile-menu-toggle">
          {open ? <X strokeWidth={1.5} /> : <Menu strokeWidth={1.5} />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden flex flex-col gap-5 px-6 pb-8 pt-2 border-t border-[#E5E0D8]" data-testid="mobile-menu">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={linkCls} onClick={() => setOpen(false)}>{n.label}</NavLink>
          ))}
          <Link to="/bestill" onClick={() => setOpen(false)} className="px-5 py-3 bg-[#1A1A1A] text-[#FDFBF7] text-sm text-center">Bestill tid</Link>
        </nav>
      )}
    </header>
  );
};
